import { render } from "./Visionaries.vue?vue&type=template&id=f705b458"
import script from "./Visionaries.vue?vue&type=script&lang=js"
export * from "./Visionaries.vue?vue&type=script&lang=js"

import exportComponent from "/Users/matthew/Documents/Vault/code/clients/inmaat/vue/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__